import Vue from 'vue'
import { generateColumnId, generateElementId, generateRowId, generateSectionId, getParentDOM,
  forceJson, } from './helper'

const manageEditorDOM = (target) => {
  let parent = getParentDOM(target, 'ne-element')
  if (parent) {
    const sectionId = parent.getAttribute('data-section-id')
    const rowId = parent.getAttribute('data-row-id')
    const columnId = parent.getAttribute('data-column-id')
    const elementId = parent.getAttribute('data-element-id')
    const elementKey = parent.getAttribute('data-element-key')
    if (sectionId && rowId && columnId && elementId && elementKey) {
      return {
        sectionId,
        rowId,
        columnId,
        id: elementId,
        key: elementKey,
        type: 'element'
      }
    }
  }
  parent = getParentDOM(target, 'ne-column-child')
  if (parent) {
    const sectionId = parent.getAttribute('data-section-id')
    const rowId = parent.getAttribute('data-row-id')
    const columnId = parent.getAttribute('data-column-id')
    if (sectionId && rowId && columnId) {
      return {
        sectionId,
        rowId,
        id: columnId,
        type: 'column'
      }
    }
  }
  parent = getParentDOM(target, 'ne-row-child')
  if (parent) {
    const sectionId = parent.getAttribute('data-section-id')
    const rowId = parent.getAttribute('data-row-id')
    if (sectionId && rowId) {
      return {
        sectionId,
        id: rowId,
        type: 'row'
      }
    }
  }
  parent = getParentDOM(target, 'ne-column')
  if (parent) {
    const sectionId = parent.getAttribute('data-section-id')
    const rowId = parent.getAttribute('data-row-id')
    const columnId = parent.getAttribute('data-column-id')
    if (sectionId && rowId && columnId) {
      return {
        sectionId,
        rowId,
        id: columnId,
        type: 'column'
      }
    }
  }
  parent = getParentDOM(target, 'ne-row')
  if (parent) {
    const sectionId = parent.getAttribute('data-section-id')
    const rowId = parent.getAttribute('data-row-id')
    if (sectionId && rowId) {
      return {
        sectionId,
        id: rowId,
        type: 'row'
      }
    }
  }
  parent = getParentDOM(target, 'ne-section')
  if (parent) {
    const sectionId = parent.getAttribute('data-section-id')
    if (sectionId) {
      return {
        id: sectionId,
        type: 'section'
      }
    }
  }
  return null
}
const calcResizeData = (e, resizeData) => {
  if (!resizeData || !resizeData.wrapperWidth) {
    return [0, 0]
  }
  const widthSum = (resizeData.startWidth || 0) + (resizeData.startWidthNext || 0)
  const percentSum = parseFloat((parseFloat(widthSum / resizeData.wrapperWidth) * 100).toFixed(2))
  const newWidth = (resizeData.startWidth || 0) + e.clientX - (resizeData.startX || 0)
  let newPercent = parseFloat((parseFloat(newWidth / resizeData.wrapperWidth) * 100).toFixed(2))
  if (newPercent < 10) {
    newPercent = 10
  } else if (percentSum - newPercent < 10) {
    newPercent = percentSum - 10
  }
  return [newPercent, percentSum - newPercent]
}
const refreshSingleElementOption = (singleOption, theme) => {
  if (theme && Object.keys(theme).length) {
    if (singleOption.FontFamily && !singleOption.FontFamilyChanged) {
      singleOption.FontFamily = theme.GlobalFontFamily
    }
    if (singleOption.TitleFontFamily && !singleOption.TitleFontFamilyChanged) {
      singleOption.TitleFontFamily = theme.GlobalFontFamily
    }
    if (singleOption.BodyFontFamily && !singleOption.BodyFontFamilyChanged) {
      singleOption.BodyFontFamily = theme.GlobalFontFamily
    }
    if (singleOption.Button && Object.keys(singleOption.Button).length && !singleOption.Button.FontFamilyChanged) {
      singleOption.Button.FontFamily = theme.GlobalFontFamily
    }
    if (singleOption.Button2 && Object.keys(singleOption.Button2).length && !singleOption.Button2.FontFamilyChanged) {
      singleOption.Button2.FontFamily = theme.GlobalFontFamily
    }
  }
  return singleOption
}
const refreshCopyElement = (options2, element, extraOptions2 = null) => {
  const elementIdOrg = element.id
  const elementId = generateElementId(element.prefix || element.key)
  const elementOption = forceJson(extraOptions2 ? extraOptions2[elementIdOrg] : options2[elementIdOrg])
  if (element.key === 'photoGallery' && !extraOptions2) {
    // Non-Block Photo Gallery
    elementOption.Items = []
  }
  options2 = {
    ...options2,
    [elementId]: refreshSingleElementOption(elementOption, options2.theme || {})
  }
  return { options2, elementId }
}
const refreshCopyColumn = (options2, column, extraOptions2 = null) => {

  for (let i = 0; i < column?.rows?.length; i++) {
    const response = refreshCopyRow(options2, column.rows[i], extraOptions2)
    options2 = { ...response.options2 }
    column.rows[i] = { ...response.row }
  }
  const columnIdOrg = column.id
  column.id = generateColumnId()
  options2 = {
    ...options2,
    [column.id]: forceJson(extraOptions2 ? extraOptions2[columnIdOrg] : options2[columnIdOrg])
  }
  // Iterate Elements
  for (let i = 0; i < column.elements.length; i++) {
    const response = refreshCopyElement(options2, column.elements[i], extraOptions2)
    options2 = { ...response.options2 }
    column.elements[i].id = response.elementId
  }
  return { options2, column }
}
const refreshCopyRow = (options2, row, extraOptions2 = null) => {
  const rowIdOrg = row.id
  row.id = generateRowId()
  options2 = {
    ...options2,
    [row.id]: forceJson(extraOptions2 ? extraOptions2[rowIdOrg] : options2[rowIdOrg])
  }
  // Iterate Columns
  for (let i = 0; i < row.columns.length; i++) {
    const response = refreshCopyColumn(options2, row.columns[i], extraOptions2)
    options2 = { ...response.options2 }
    row.columns[i] = { ...response.column }
  }
  return { options2, row }
}
const refreshCopySection = (options2, section, extraOptions2 = null) => {
  const sectionIdOrg = section.id
  section.id = generateSectionId()
  options2 = {
    ...options2,
    [section.id]: forceJson(extraOptions2 ? extraOptions2[sectionIdOrg] : options2[sectionIdOrg])
  }
  // Iterate Rows
  for (let i = 0; i < section.rows.length; i++) {
    const response = refreshCopyRow(options2, section.rows[i], extraOptions2)
    options2 = { ...response.options2 }
    section.rows[i] = { ...response.row }
  }
  return { options2, section }
}
const copyIdNE = ($ref) => {
  $ref.select()
  $ref.setSelectionRange(0, 999999)
  document.execCommand('copy')
  Vue.$toast.open({
    message: 'Copied',
    type: 'success',
    duration: 5000
  })
}
const clickDesktopNE = ($object) => {
  switch ($object.Visibility) {
    case 'both':
      $object.Visibility = 'mobile'
    break
    case 'desktop':
      $object.Visibility = ''
    break
    case 'mobile':
      $object.Visibility = 'both'
    break
    default:
      $object.Visibility = 'desktop'
    break
  }
}
const clickMobileNE = ($object) => {
  switch ($object.Visibility) {
    case 'both':
      $object.Visibility = 'desktop'
    break
    case 'desktop':
      $object.Visibility = 'both'
    break
    case 'mobile':
      $object.Visibility = ''
    break
    default:
      $object.Visibility = 'mobile'
    break
  }
}
const getBorderStyleNE = (elementOption, prefix = '') => {
  let style = {}
  if (elementOption[`${prefix}Border`]) {
    style = {
      borderStyle: elementOption[`${prefix}BorderStyle`] || 'solid',
      borderRadius: `${elementOption[`${prefix}RadiusEdge`] !== 'bottomonly' ? (elementOption[`${prefix}BorderRadius`] || 0) : 0}px ${elementOption[`${prefix}RadiusEdge`] !== 'bottomonly' ? (elementOption[`${prefix}BorderRadius`] || 0) : 0}px ${elementOption[`${prefix}RadiusEdge`] !== 'toponly' ? (elementOption[`${prefix}BorderRadius`] || 0) : 0}px ${elementOption[`${prefix}RadiusEdge`] !== 'toponly' ? (elementOption[`${prefix}BorderRadius`] || 0) : 0}px`,
      borderColor: elementOption[`${prefix}BorderColor`] || '#00000000'
    }
    switch (elementOption[`${prefix}Border`]) {
      case 'top':
        style.borderWidth = `${elementOption[`${prefix}BorderWidth`]}px 0px 0px 0px`
      break
      case 'bottom':
        style.borderWidth = `0px 0px ${elementOption[`${prefix}BorderWidth`]}px 0px`
      break
      case 'topbottom':
        style.borderWidth = `${elementOption[`${prefix}BorderWidth`]}px 0px ${elementOption[`${prefix}BorderWidth`]}px 0px`
      break
      case 'left':
        style.borderWidth = `0px 0px 0px ${elementOption[`${prefix}BorderWidth`]}px`
      break
      case 'right':
        style.borderWidth = `0px ${elementOption[`${prefix}BorderWidth`]}px 0px 0px`
      break
      case 'leftright':
        style.borderWidth = `0px ${elementOption[`${prefix}BorderWidth`]}px 0px ${elementOption[`${prefix}BorderWidth`]}px`
      break
      case 'full':
        style.borderWidth = `${elementOption[`${prefix}BorderWidth`]}px`
      break
    }
  }
  return style
}
const getBGPositionStyleNE = (position) => {
  let style = {}
  switch (position) {
    case 'fullcenterfit':
      style = {
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: 'cover'
      }
    break
    case 'fillwidth':
      style = {
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% auto'
      }
    break
    case 'norepeat':
      style = {
        backgroundRepeat: 'no-repeat'
      }
    break
    case 'repeat':
      style = {
        backgroundRepeat: 'repeat'
      }
    break
    case 'repeatH':
      style = {
        backgroundRepeat: 'repeat-x'
      }
    break
    case 'repeatV':
      style = {
        backgroundRepeat: 'repeat-y'
      }
    break
    case 'repeatHTop':
      style = {
        backgroundRepeat: 'repeat-x',
        backgroundPosition: 'top center'
      }
    break
    case 'repeatHBottom':
      style = {
        backgroundRepeat: 'repeat-x',
        backgroundPosition: 'bottom center'
      }
    break
  }
  return style
}
const selectInputThemeNE = ($object, themeName) => {
  $object.TextColor = '#4B4B5A'
  $object.ControlBackgroundColor = '#FFFFFF'
  $object.ControlBackgroundGradient = null
  $object.Border = 'full'
  $object.BorderStyle = 'solid'
  $object.BorderWidth = '1'
  $object.BorderRadius = '5'
  $object.BorderColor = '#00000033'
  $object.RadiusEdge = 'all'
  $object.BoxShadow = null
  switch (themeName) {
    case 'default':
      $object.CustomBoxShadow = null
    break
    case 'gray':
      $object.CustomBoxShadow = 'inset 0px 0px 2px 2px rgba(0, 0, 0, 0.055)'
    break
    case 'lightgray':
      $object.CustomBoxShadow = 'inset 0px 2px 4px rgba(128, 128, 128, 0.15), 0px 3px 2px rgba(140, 157, 169, 0.14)'
    break
    case 'borderwhite':
      $object.CustomBoxShadow = '0 0 0 3px rgba(0, 0, 0, 0.05)'
    break
    case 'simple':
      $object.CustomBoxShadow = '0px 0px 0px 1px rgba(0, 0, 0, 0.12)'
      $object.Border = 'bottom'
      $object.BorderColor = '#00000021'
      $object.BorderWidth = '3'
    break
    case '3dgradient':
      $object.CustomBoxShadow = '0px 0px 0px 1px rgba(0, 0, 0, 0.12)'
      $object.Border = 'bottom'
      $object.BorderColor = '#00000021'
      $object.BorderWidth = '3'
      $object.ControlBackgroundGradient = '-webkit-gradient(linear, center top, center bottom, color-stop(0%, #FFF), color-stop(100%, #EFEFEF))'
    break
    case 'simpleclean':
      $object.CustomBoxShadow = '0 0 6px rgba(2, 117, 216, 0.4)'
      $object.BorderColor = '#0275D8B3'
      $object.BorderWidth = '1'
    break
    case 'blackunderline':
      $object.CustomBoxShadow = null
      $object.Border = 'bottom'
      $object.BorderColor = '#000000'
      $object.BorderWidth = '2'
    break
  }
}
const selectThemeNE = ($object, themeName) => {
  $object.Theme = themeName
  $object.ButtonBackgroundColor = '#0174C7'
  $object.TextColor = '#FFFFFF'
  $object.RadiusEdge = 'all'
  switch (themeName) {
    case '3d':
      $object.BoxShadow = 'inset 0 0 0 2px rgb(255 255 255 / 20%)'
      $object.TextShadow = '1px 1px 0px rgb(0 0 0 / 20%)'
      $object.HoverClass = 'doubleInset'
      $object.Border = 'full'
      $object.BorderRadius = '3'
      $object.BorderWidth = '1'
      $object.BorderStyle = 'solid'
      $object.BorderColor = '#00000033'
    break
    case 'square':
      $object.BoxShadow = ''
      $object.TextShadow = ''
      $object.HoverClass = ''
      $object.Border = 'full'
      $object.BorderRadius = '3'
      $object.BorderWidth = '1'
      $object.BorderStyle = 'solid'
      $object.BorderColor = '#00000000'
    break
    case '5pt-corner':
      $object.BoxShadow = 'inset 0 1px 0 rgb(255 255 255 / 20%)'
      $object.TextShadow = ''
      $object.HoverClass = 'doubleInset'
      $object.Border = 'full'
      $object.BorderRadius = '5'
      $object.BorderWidth = '1'
      $object.BorderStyle = 'solid'
      $object.BorderColor = '#00000033'
    break
    case '10pt-corner':
      $object.BoxShadow = 'inset 0 1px 0 rgb(255 255 255 / 20%)'
      $object.TextShadow = ''
      $object.HoverClass = 'doubleInset'
      $object.Border = 'full'
      $object.BorderRadius = '10'
      $object.BorderWidth = '1'
      $object.BorderStyle = 'solid'
      $object.BorderColor = '#00000033'
    break
    case '15pt-corner':
      $object.BoxShadow = 'inset 0 1px 0 rgb(255 255 255 / 20%)'
      $object.TextShadow = ''
      $object.HoverClass = 'doubleInset'
      $object.Border = 'full'
      $object.BorderRadius = '15'
      $object.BorderWidth = '1'
      $object.BorderStyle = 'solid'
      $object.BorderColor = '#00000033'
    break
    case '20pt-corner':
      $object.BoxShadow = 'inset 0 1px 0 rgb(255 255 255 / 20%)'
      $object.TextShadow = ''
      $object.HoverClass = 'doubleInset'
      $object.Border = 'full'
      $object.BorderRadius = '20'
      $object.BorderWidth = '1'
      $object.BorderStyle = 'solid'
      $object.BorderColor = '#00000033'
    break
    case 'pill':
      $object.BoxShadow = ''
      $object.TextShadow = ''
      $object.HoverClass = ''
      $object.Border = 'full'
      $object.BorderRadius = '500'
      $object.BorderWidth = '1'
      $object.BorderStyle = 'solid'
      $object.BorderColor = '#00000000'
    break
  }
}
const clickIconThemeNE = ($object, themeKey) => {
  $object.IconTheme = themeKey
  $object.BoxShadow = null
  switch (themeKey) {
    case 'default':
    case 'text-shadow':
      $object.IsIconGradientBG = false
      $object.IconBackgroundColor = '#FFFFFF00'
      $object.IconPaddingTop = 0
      $object.IconPaddingBottom = 0
      $object.IconPaddingLeft = 0
      $object.IconPaddingRight = 0
      $object.IconColor = '#444444'
      $object.IconSize = 80
      $object.Border = null
    break
    case 'boxed':
      $object.IsIconGradientBG = false
      $object.IconBackgroundColor = '#FAFAFA'
      $object.IconPaddingTop = 16
      $object.IconPaddingBottom = 16
      $object.IconPaddingLeft = 20
      $object.IconPaddingRight = 20
      $object.IconColor = '#444444'
      $object.IconSize = 80
      $object.Border = 'full'
      $object.BorderStyle = 'solid'
      $object.BorderWidth = '2'
      $object.BorderColor = '#00000013'
      $object.BorderRadius = '4'
    break
    case 'circle':
      $object.IsIconGradientBG = false
      $object.IconBackgroundColor = '#FAFAFA'
      $object.IconPaddingTop = 24
      $object.IconPaddingBottom = 24
      $object.IconPaddingLeft = 28
      $object.IconPaddingRight = 28
      $object.IconColor = '#444444'
      $object.IconSize = 80
      $object.Border = 'full'
      $object.BorderStyle = 'solid'
      $object.BorderWidth = '2'
      $object.BorderColor = '#00000013'
      $object.BorderRadius = '100'
    break
    case 'blue-boxed':
      $object.IsIconGradientBG = false
      $object.IconBackgroundColor = '#0074C7'
      $object.IconPaddingTop = 16
      $object.IconPaddingBottom = 16
      $object.IconPaddingLeft = 20
      $object.IconPaddingRight = 20
      $object.IconColor = '#FFFFFF'
      $object.IconSize = 80
      $object.Border = 'full'
      $object.BorderStyle = 'solid'
      $object.BorderWidth = '2'
      $object.BorderColor = '#00000026'
      $object.BorderRadius = '4'
    break
    case 'green-boxed':
      $object.IsIconGradientBG = true
      $object.IconBackgroundColor = '#CBE951'
      $object.IconPaddingTop = 16
      $object.IconPaddingBottom = 16
      $object.IconPaddingLeft = 20
      $object.IconPaddingRight = 20
      $object.IconColor = '#FFFFFF'
      $object.IconSize = 80
      $object.Border = 'full'
      $object.BorderStyle = 'solid'
      $object.BorderWidth = '1'
      $object.BorderColor = '#53A40C'
      $object.BorderRadius = '4'
    break
    case 'red-boxed':
      $object.IsIconGradientBG = true
      $object.IconBackgroundColor = '#F8674B'
      $object.IconPaddingTop = 16
      $object.IconPaddingBottom = 16
      $object.IconPaddingLeft = 20
      $object.IconPaddingRight = 20
      $object.IconColor = '#FFFFFF'
      $object.IconSize = 80
      $object.Border = 'full'
      $object.BorderStyle = 'solid'
      $object.BorderWidth = '1'
      $object.BorderColor = '#D1371C'
      $object.BorderRadius = '4'
    break
    case 'yellow-boxed':
      $object.IsIconGradientBG = true
      $object.IconBackgroundColor = '#FFD683'
      $object.IconPaddingTop = 16
      $object.IconPaddingBottom = 16
      $object.IconPaddingLeft = 20
      $object.IconPaddingRight = 20
      $object.IconColor = '#FFFFFF'
      $object.IconSize = 80
      $object.Border = 'full'
      $object.BorderStyle = 'solid'
      $object.BorderWidth = '1'
      $object.BorderColor = '#E6791C'
      $object.BorderRadius = '4'
    break
    case 'gray-boxed':
      $object.IsIconGradientBG = true
      $object.IconBackgroundColor = '#F4F5F7'
      $object.IconPaddingTop = 16
      $object.IconPaddingBottom = 16
      $object.IconPaddingLeft = 20
      $object.IconPaddingRight = 20
      $object.IconColor = '#444444'
      $object.IconSize = 80
      $object.Border = 'full'
      $object.BorderStyle = 'solid'
      $object.BorderWidth = '1'
      $object.BorderColor = '#949494'
      $object.BorderRadius = '4'
    break
    case 'purple-boxed':
      $object.IsIconGradientBG = true
      $object.IconBackgroundColor = '#637AAD'
      $object.IconPaddingTop = 16
      $object.IconPaddingBottom = 16
      $object.IconPaddingLeft = 20
      $object.IconPaddingRight = 20
      $object.IconColor = '#FFFFFF'
      $object.IconSize = 80
      $object.Border = 'full'
      $object.BorderStyle = 'solid'
      $object.BorderWidth = '1'
      $object.BorderColor = '#314179'
      $object.BorderRadius = '4'
    break
    case 'dark-boxed':
      $object.IsIconGradientBG = true
      $object.IconBackgroundColor = '#777777'
      $object.IconPaddingTop = 16
      $object.IconPaddingBottom = 16
      $object.IconPaddingLeft = 20
      $object.IconPaddingRight = 20
      $object.IconColor = '#FFFFFF'
      $object.IconSize = 80
      $object.Border = 'full'
      $object.BorderStyle = 'solid'
      $object.BorderWidth = '1'
      $object.BorderColor = '#323232'
      $object.BorderRadius = '4'
    break
  }
}
const selectTimerThemeNE = ($object, themeKey) => {
  $object.ControlBoxShadow = null
  $object.TitleFontSize = 32
  $object.TitleFontWeight = '700'
  $object.BodyFontSize = 12
  $object.BodyFontWeight = '400'
  $object.BodyTextColor = '#00000066'
  if (['default', 'blue', 'green', 'red'].includes(themeKey)) {
    $object.ControlPaddingTop = 0
    $object.ControlPaddingBottom = 0
    $object.ControlPaddingLeft = 6
    $object.ControlPaddingRight = 6
    $object.ControlBackgroundColor = '#FFFFFF00'
    $object.ControlBackgroundGradient = null
    $object.CustomControlBoxShadow = null
    $object.ControlBorder = null
    if (themeKey === 'default') {
      $object.TitleTextColor = '#2E2E2E'
    } else if (themeKey === 'blue') {
      $object.TitleTextColor = '#26789D'
    } else if (themeKey === 'green') {
      $object.TitleTextColor = '#668B42'
    } else if (themeKey === 'red') {
      $object.TitleTextColor = '#C41229'
    }
  } else if (['blackcircle', 'bluecircle', 'greencircle', 'redcircle', 'yellowcircle'].includes(themeKey)) {
    $object.ControlPaddingTop = 16
    $object.ControlPaddingBottom = 16
    $object.ControlPaddingLeft = 2
    $object.ControlPaddingRight = 2
    $object.ControlBackgroundColor = '#FFFFFF00'
    $object.CustomControlBoxShadow = '0 1px 5px rgba(0, 0, 0, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.2)'
    $object.ControlBorder = 'full'
    $object.ControlBorderStyle = 'solid'
    $object.ControlBorderWidth = '4'
    $object.ControlBorderRadius = '100'
    $object.ControlRadiusEdge = 'all'
    if (themeKey === 'blackcircle') {
      $object.TitleTextColor = '#FFFFFF'
      $object.ControlBackgroundGradient = 'linear-gradient(to bottom, #444 0%, #2E2E2E 100%)'
      $object.ControlBorderColor = '#2E2E2E'
    } else if (themeKey === 'bluecircle') {
      $object.TitleTextColor = '#154058'
      $object.ControlBackgroundGradient = 'linear-gradient(to bottom, #49A4CC 0%, #26789D 100%)'
      $object.ControlBorderColor = '#26789D'
    } else if (themeKey === 'greencircle') {
      $object.TitleTextColor = '#2A4315'
      $object.ControlBackgroundGradient = 'linear-gradient(to bottom, #77BA34 0%, #668B42 100%)'
      $object.ControlBorderColor = '#668B42'
    } else if (themeKey === 'redcircle') {
      $object.TitleTextColor = '#43010F'
      $object.ControlBackgroundGradient = 'linear-gradient(to bottom, #E5162F 0%, #C41229 100%)'
      $object.ControlBorderColor = '#C41229'
    } else if (themeKey === 'yellowcircle') {
      $object.TitleTextColor = '#42251F'
      $object.ControlBackgroundGradient = 'linear-gradient(to bottom, #FEEA69 0%, #E29323 100%)'
      $object.ControlBorderColor = '#E29323'
    }
  } else if (['blackrect', 'bluerect', 'greenrect', 'redrect', 'yellowrect'].includes(themeKey)) {
    $object.ControlPaddingTop = 14
    $object.ControlPaddingBottom = 14
    $object.ControlPaddingLeft = 4
    $object.ControlPaddingRight = 4
    $object.ControlBorder = 'full'
    $object.ControlBorderStyle = 'solid'
    $object.ControlBorderWidth = '2'
    $object.ControlBorderRadius = '5'
    $object.ControlRadiusEdge = 'all'
    $object.ControlBorderColor = '#00000033'
    $object.ControlBackgroundGradient = null
    $object.CustomControlBoxShadow = null
    if (themeKey === 'blackrect') {
      $object.ControlBackgroundColor = '#2E2E2E'
      $object.TitleTextColor = '#FFFFFF'
    } else if (themeKey === 'bluerect') {
      $object.ControlBackgroundColor = '#26789D'
      $object.TitleTextColor = '#FFFFFF'
    } else if (themeKey === 'greenrect') {
      $object.ControlBackgroundColor = '#668B42'
      $object.TitleTextColor = '#FFFFFF'
    } else if (themeKey === 'redrect') {
      $object.ControlBackgroundColor = '#C41229'
      $object.TitleTextColor = '#FFFFFF'
    } else if (themeKey === 'yellowrect') {
      $object.ControlBackgroundColor = '#FEE068'
      $object.TitleTextColor = '#42251F'
    }
  } else if (['blackrectshadow', 'bluerectshadow', 'greenrectshadow', 'redrectshadow', 'yellowrectshadow'].includes(themeKey)) {
    $object.ControlPaddingTop = 14
    $object.ControlPaddingBottom = 14
    $object.ControlPaddingLeft = 4
    $object.ControlPaddingRight = 4
    $object.ControlBackgroundColor = '#FFFFFF00'
    $object.ControlBorder = 'full'
    $object.ControlBorderStyle = 'solid'
    $object.ControlBorderWidth = '2'
    $object.ControlBorderRadius = '5'
    $object.ControlRadiusEdge = 'all'
    $object.CustomControlBoxShadow = '0 1px 5px rgba(0, 0, 0, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.2)'
    if (themeKey === 'blackrectshadow') {
      $object.TitleTextColor = '#FFFFFF'
      $object.ControlBorderColor = '#2E2E2E'
      $object.ControlBackgroundGradient = 'linear-gradient(to bottom, #444 0%, #2E2E2E 100%)'
    } else if (themeKey === 'bluerectshadow') {
      $object.TitleTextColor = '#154058'
      $object.ControlBorderColor = '#26789D'
      $object.ControlBackgroundGradient = 'linear-gradient(to bottom, #49A4CC 0%, #26789D 100%)'
    } else if (themeKey === 'greenrectshadow') {
      $object.TitleTextColor = '#2A4315'
      $object.ControlBorderColor = '#668B42'
      $object.ControlBackgroundGradient = 'linear-gradient(to bottom, #77BA34 0%, #668B42 100%)'
    } else if (themeKey === 'redrectshadow') {
      $object.TitleTextColor = '#43010F'
      $object.ControlBorderColor = '#C41229'
      $object.ControlBackgroundGradient = 'linear-gradient(to bottom, #E5162F 0%, #C41229 100%)'
    } else if (themeKey === 'yellowrectshadow') {
      $object.TitleTextColor = '#42251F'
      $object.ControlBorderColor = '#E29323'
      $object.ControlBackgroundGradient = 'linear-gradient(to bottom, #FEEA69 0%, #E29323 100%)'
    }
  } else if (['blackcircleoutline', 'bluecircleoutline', 'greencircleoutline', 'redcircleoutline', 'yellowcircleoutline'].includes(themeKey)) {
    $object.ControlPaddingTop = 16
    $object.ControlPaddingBottom = 16
    $object.ControlPaddingLeft = 2
    $object.ControlPaddingRight = 2
    $object.ControlBackgroundColor = '#FFFFFF00'
    $object.ControlBorder = 'full'
    $object.ControlBorderStyle = 'solid'
    $object.ControlBorderWidth = '4'
    $object.ControlBorderRadius = '100'
    $object.ControlRadiusEdge = 'all'
    $object.ControlBackgroundGradient = null
    $object.CustomControlBoxShadow = null
    if (themeKey === 'blackcircleoutline') {
      $object.TitleTextColor = '#2E2E2E'
      $object.ControlBorderColor = '#2E2E2E'
    } else if (themeKey === 'bluecircleoutline') {
      $object.TitleTextColor = '#26789D'
      $object.ControlBorderColor = '#26789D'
    } else if (themeKey === 'greencircleoutline') {
      $object.TitleTextColor = '#668B42'
      $object.ControlBorderColor = '#668B42'
    } else if (themeKey === 'redcircleoutline') {
      $object.TitleTextColor = '#C41229'
      $object.ControlBorderColor = '#C41229'
    } else if (themeKey === 'yellowcircleoutline') {
      $object.TitleTextColor = '#FEE068'
      $object.ControlBorderColor = '#FEE068'
    }
  }
}
export {
  manageEditorDOM,
  calcResizeData,
  refreshSingleElementOption,
  refreshCopyElement,
  refreshCopyColumn,
  refreshCopyRow,
  refreshCopySection,
  copyIdNE,
  clickDesktopNE,
  clickMobileNE,
  getBorderStyleNE,
  getBGPositionStyleNE,
  selectInputThemeNE,
  selectThemeNE,
  clickIconThemeNE,
  selectTimerThemeNE
}